import {useSuspenseQuery} from "@tanstack/react-query";
import {useMemo} from "react";
import {secretApi} from "../../../api/api";
import {getRegion} from "../../../function";

export const useSliApi = () => {
    const query = useSuspenseQuery(
        {
            queryKey: ['sliApi'],
            queryFn: async () => {
                const best = await best_api()
                const all_teams = await all_teams_api()
                const tournament = await sll_tournament()
                return {best, all_teams, tournament}
            },
            staleTime: Infinity,
        })


    const list = useMemo(() => {
        if (!query?.data) {
            return {best: {}, all_teams: {}, tournament: {A: [], B: [], FINALS: []}}
        }
        return query.data
    }, [query.data])

    return {query, list};
}


const getMatchDataAPI = (action) => {
    const changeRegion = getRegion(action.region);
    const url = `${process.env.REACT_APP_CACHE_API}match/match-cached?match_id=${action.matchId}&platform_id=${changeRegion}`
    return secretApi.get(url).then((res) => res.data);
}

const best_api = async () => {
    try {
        // const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_first_player`);
        const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_first_player`);

        const result = await secretApi.get(url.toString());
        const best = result.data.first_ai_score.best;

        result.data.first_ai_score.best = best

        const data = result.data.first_ai_score
        const topMatchId = data.TOP.match_id
        const jungleMatchId = data.JUNGLE.match_id
        const middleMatchId = data.MIDDLE.match_id
        const botMatchId = data.BOTTOM.match_id
        const supMatchId = data.UTILITY.match_id
        const bestMatchId = data?.best?.match_id


        const matchIds = [topMatchId, jungleMatchId, middleMatchId, botMatchId, supMatchId, bestMatchId]

        const matches = await Promise.all(matchIds.map((data) => {
            return getMatchDataAPI({matchId: data, platform_id: 'KR'})
        }))

        result.data.first_ai_score.TOP.match = matches[0]
        result.data.first_ai_score.JUNGLE.match = matches[1]
        result.data.first_ai_score.MIDDLE.match = matches[2]
        result.data.first_ai_score.BOTTOM.match = matches[3]
        result.data.first_ai_score.UTILITY.match = matches[4]
        result.data.first_ai_score.best.match = matches[5]


        return result?.data?.first_ai_score;
    } catch (e) {
        console.log(e)
        return {};
    }
}


const all_teams_api = async () => {
    try {
        // const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_first_player`);
        const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_all_team`);
        const result = await secretApi.get(url.toString());
        const array = Object.entries(result.data.all_team_data).reduce((sum, cur) => {
            cur[1].team_name = cur[0];
            const playerList = Object.values(cur[1]).reduce((sum, cur) => {
                if (typeof cur === 'object') {
                    sum.push(cur)
                }
                return sum
            }, [])
            cur[1].players = playerList;
            sum.push(cur[1])
            console.log(playerList)
            return sum
        }, []);
        return array
    } catch (e) {
        return []
    }
}


const sll_tournament = async () => {
    try {
        // const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_first_player`);
        const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_tournament`);
        const result = await secretApi.get(url.toString());
        const data = result.data.tournament_data

        const groupA = tournamentMapData(Object.values(data['A']))
        const groupB = tournamentMapData(Object.values(data.B))
        const finals = tournamentMapData(Object.values(data.FINALS))


        return {
            A: groupA,
            B: groupB,
            FINALS: finals
        }
    } catch (e) {
        console.log(e)
        return {A: [], B: [], FINALS: []}
    }
}


const tournamentMapData = (mapData) => {
    const map = mapData.map((data) => {
        return data.map((item) => {
            const entreis = Object.entries(item)
            return {
                team: entreis[0][0] === '???' ? '????' : entreis[0][0],
                isWin: entreis[0][1]
            }
        })
    });
    return map
}